module.exports = __webpack_public_path__ + "static/media/8n.822382d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/8n.svg
// module id = 161
// module chunks = 0